/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AudioTriggerGroup from './AudioTriggerGroup';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Represents a group of [[cc.AudioSource]]s in which one is randomly
 * played each time its cue is triggered.
 */
@cc._decorator.ccclass
export default class AudioTriggerRandom extends AudioTriggerGroup
{
    /** Whether or not the [[cc.AudioSource]]s should be allowed to play over one another. */
    @property({ visible: true })
    private _allowOverplay: boolean = false;

    /** @hidden */
    private _lastSource: cc.AudioSource = null;

    /** Plays one of the associated [[cc.AudioSource]]s at random. */
    public Trigger(): void
    {
        if (!this._audioSources || this._audioSources.length < 1) { return null; }

        if (!this._allowOverplay
            && !this.noInterrupt
            && this._lastSource
            && this._lastSource.isPlaying)
        {
            this._lastSource.stop();
        }

        if ((this._lastSource
            && this._lastSource.isPlaying
            && this._allowOverplay)
                || !this._lastSource
                || !this._lastSource.isPlaying)
        {
            let initialIndex: number = Math.floor(Math.random() * this._audioSources.length);
            let index: number = initialIndex;

            if (this.noInterrupt)
            {
                // Find a random audio source that isn't in use.
                while (this._audioSources[index].isPlaying)
                {
                    index = (index + 1) % this._audioSources.length;
                    if (index === initialIndex) { return; }
                }
            }

            this._lastSource = this._audioSources[index];
            this.playAudioSource(this._lastSource);
            this.isStarted = true;
        }
    }
}
